module.exports = "/img/city-auckland.b26bae94.jpg";